import BaseAssetsCollection from 'backbone/platform/collections/assets/base_assets_collection.js'
import MediaLibraryAsset from 'backbone/platform/models/assets/media_library_asset.js'

export default class MediaLibraryAssetCollection extends BaseAssetsCollection
  model: MediaLibraryAsset

  reverse: false

  initialize: (models, options = {}) ->
    @brandProfileId = options.brandProfileId
    @filters = {}
    @availableCreators = []
    @page = options.page || 1
    @allAssetsLoaded = false
    @loadingAssets = false
    super

  url: ->
    url = "/media?brand_profile_id=#{@brandProfileId}"
    for filter, value of @filters
      url += "&#{filter}=#{value}"
    url += "&query=#{@query}" if @query
    url

  fetchNextPage: (options) ->
    @loadingAssets = true

    @assetRequest = $.ajax(
      url: @url() + "&page=#{@page + 1}"
      type: 'GET',
      dataType: 'json',
      success: (data) =>
        @assetLoadedSuccess(data.assets)
        options.success() if options.success
      error: ->
        options.error() if options.error
    ).always ->
      options.always() if options.always

  assetLoadedSuccess: (assets) =>
    if !assets || assets.length == 0
      @allAssetsLoaded = true
    else
      @add(asset) for asset in assets
      @page++

    @loadingAssets = false

  parse: (data) ->
    @filterable_tags = data.filterable_tags
    data.assets

  setFilter: (filter, value) ->
    if value == ''
      delete @filters[filter]
    else
      @filters[filter] = value

  setQuery: (query) ->
    @query = query

  resetFilters: ->
    @filters = {}

  hasNoFilters: ->
    _.isEqual @filters, {}

  creators: ->
    return @availableCreators if @availableCreators.length > 0

    allCreators = @map (item) -> [item.get("creatorId"), item.get("creatorName")]
    @availableCreators = _.uniq allCreators, (creator) -> creator[0]

  tags: ->
    @filterable_tags || []

  deselectAll: ->
    @each (asset) ->
      asset.set("selected", false)



// WEBPACK FOOTER //
// ./app/javascript/backbone/platform/collections/assets/media_library_asset_collection.js.coffee